import { icons } from './searchAssets'
import { formatMessage } from './strings/intl/intlHooks'
import { messages } from './strings/messages'
import { Coordinator } from '../navigation/coordinator/coordinator'
import { showMessageSnackbar } from '../components/snackbar/Snackbar'

export enum AppModules {
  Custom = 'custom',
  Schedule = 'schedule',
  Constructions = 'construction',
  Financial = 'financial',
}

export const goToNotificationScreen = module => {
  switch (module) {
    case AppModules.Financial:
      return Coordinator.goToFinance()
    case AppModules.Constructions:
      return Coordinator.goToConstructions()
    case AppModules.Schedule:
      return Coordinator.goToAppointments()
    default:
      return null
  }
}

export const getModuleIconForNotification = (module, type) => {
  switch (module) {
    case AppModules.Schedule:
      return icons.date
    case AppModules.Constructions:
      if (type === AppTypes.NewConstructionMedia) {
        return icons.constructionsMedia
      } else if (type === AppTypes.DeliveryKeysSchedule) {
        return icons.keyIcon
      } else {
        return icons.construction
      }
    case AppModules.Financial:
      return icons.monetization
    case AppModules.Custom:
      return icons.avatarLogin
    default:
      return null
  }
}

export enum AppTypes {
  NewConstructionMedia = 'newConstructionMedia',
  ConstructionStatusUpdate = 'constructionStatusUpdate',
  FinishedConstruction = 'finishedConstruction',
  NewInstallment = 'newInstallment',
  CloseDueDate = 'closeDueDate',
  LatePayment = 'latePayment',
  PaymentReceived = 'paymentReceived',
  VisitEventOpen = 'visitEventOpen',
  VisitEventCanceled = 'visitEventCanceled',
  WasDrawn = 'wasDrawn',
  WasNotDrawn = 'wasNotDrawn',
  VisitScheduling = 'visitScheduling',
  DeliveryKeysSchedule = 'deliveryKeysSchedule',
  CancelDeliveryKeysSchedule = 'cancelDeliveryKeysSchedule',
  Custom = 'custom',
}

export const mountNotificationBody = (type): string => {
  switch (type) {
    case AppTypes.NewConstructionMedia:
      return formatMessage(messages.notificationsScreen_type_newConstructionMedia)
    case AppTypes.ConstructionStatusUpdate:
      return formatMessage(messages.notificationsScreen_type_constructionStatusUpdate)
    case AppTypes.FinishedConstruction:
      return formatMessage(messages.notificationsScreen_type_finishedConstruction)
    case AppTypes.NewInstallment:
      return formatMessage(messages.notificationsScreen_type_newInstallment)
    case AppTypes.CloseDueDate:
      return formatMessage(messages.notificationsScreen_type_closeDueDate_installmentExpires)
    case AppTypes.LatePayment:
      return formatMessage(messages.notificationsScreen_type_latePayment)
    case AppTypes.PaymentReceived:
      return formatMessage(messages.notificationsScreen_type_paymentReceived)
    case AppTypes.VisitEventOpen:
      return formatMessage(messages.notificationsScreen_type_visitEventOpen)
    case AppTypes.VisitEventCanceled:
      return formatMessage(messages.notificationsScreen_type_visitEventCanceled)
    case AppTypes.WasDrawn:
      return formatMessage(messages.notificationsScreen_type_wasDrawn)
    case AppTypes.WasNotDrawn:
      return formatMessage(messages.notificationsScreen_type_wasNotDrawn)
    case AppTypes.VisitScheduling:
      return formatMessage(messages.notificationsScreen_type_visitScheduling_date)
    case AppTypes.DeliveryKeysSchedule:
      return formatMessage(messages.notificationsScreen_type_deliveryKeysSchedule_date)
    case AppTypes.CancelDeliveryKeysSchedule:
      return formatMessage(messages.notificationsScreen_type_cancelDeliveryKeysSchedule)
    default:
      return null
  }
}
